import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import { FavoritesIndicator } from '@surfline/quiver-react';
import resolveBreadcrumbs from '../../utils/urls/breadcrumbResolver';
import Breadcrumb from '../Breadcrumb';
import ForecastHeaderMenu from '../ForecastHeaderMenu';
import breadcrumbsPropTypes from '../../propTypes/breadcrumbs';
import userSettingsPropTypes from '../../propTypes/userSettings';
import spotPropTypes from '../../propTypes/spot';
import linkPropTypes from '../../propTypes/link';
import nearbySubregionsPropTypes from '../../propTypes/nearbySubregions';

const getClassName = active =>
  classNames({
    'sl-forecast-header__nav__page-level__link': true,
    'sl-forecast-header__nav__page-level__link--active': active,
  });

const isMultiPageSingleTabActive = (itemPath, locationPath, isMultiPage) => {
  if (!locationPath || !itemPath) return false;
  const { 1: rootPath } = locationPath.split('/');
  return isMultiPage && itemPath.indexOf(rootPath) !== -1 && locationPath.indexOf(rootPath) !== -1;
};

const ForecastHeader = ({
  breadcrumb,
  pageTitle,
  pageLevelLinks,
  pathName,
  externalLinks1,
  externalLinks2,
  nearbySpots,
  showFavorite,
  spotPage,
  userSettings,
  handleFavoriteClick,
  favorited,
  doTrackEvent,
  isMultiPage,
  nearbySubregions,
}) => (
  <div className="sl-forecast-header">
    <div className="sl-forecast-header__breadcrumb">
      <Breadcrumb breadcrumbs={resolveBreadcrumbs(breadcrumb)} />
    </div>
    <div className="sl-forecast-header__main">
      <h1 className="sl-forecast-header__main__title">{pageTitle}</h1>
      {showFavorite ? (
        <div className="sl-forecast-header__main__favorite">
          <button
            type="button"
            onClick={() => handleFavoriteClick && handleFavoriteClick(favorited)}
          >
            <FavoritesIndicator favorited={favorited} showText />
          </button>
        </div>
      ) : null}
    </div>
    <div className="sl-forecast-header__nav">
      <div className="sl-forecast-header__nav__page-level">
        {pageLevelLinks.map(item => (
          <a
            href={item.path}
            key={item.text}
            className={getClassName(
              item.path === pathName || isMultiPageSingleTabActive(item.path, pathName, isMultiPage)
            )}
            onClick={() =>
              doTrackEvent('Clicked Link', {
                linkUrl: item.path,
                linkName: item.text,
                linkLocation: spotPage
                  ? 'spot forecast navigation'
                  : 'regional forecast navigation',
                category: spotPage ? 'spot forecast' : 'regional forecast',
              })
            }
          >
            <div className="sl-forecast-header__nav__page-level__link__text">{item.text}</div>
          </a>
        ))}
      </div>
      <div className="sl-forecast-header__nav__divider" />
      <ForecastHeaderMenu
        userSettings={userSettings}
        externalLinks1={externalLinks1}
        externalLinks2={externalLinks2}
        nearbySpots={nearbySpots}
        nearbySubregions={nearbySubregions}
        spotPage={spotPage}
        doTrackEvent={doTrackEvent}
        pathName={pathName}
      />
    </div>
  </div>
);

ForecastHeader.propTypes = {
  breadcrumb: PropTypes.arrayOf(breadcrumbsPropTypes).isRequired,
  pageTitle: PropTypes.string.isRequired,
  showFavorite: PropTypes.bool,
  spotPage: PropTypes.bool,
  pageLevelLinks: PropTypes.arrayOf(linkPropTypes).isRequired,
  externalLinks1: PropTypes.arrayOf(linkPropTypes),
  externalLinks2: PropTypes.arrayOf(linkPropTypes),
  nearbySpots: PropTypes.arrayOf(spotPropTypes),
  userSettings: userSettingsPropTypes,
  handleFavoriteClick: PropTypes.func,
  favorited: PropTypes.bool,
  doTrackEvent: PropTypes.func.isRequired,
  pathName: PropTypes.string,
  isMultiPage: PropTypes.bool,
  nearbySubregions: nearbySubregionsPropTypes,
};

ForecastHeader.defaultProps = {
  userSettings: null,
  nearbySpots: null,
  nearbySubregions: null,
  favorited: false,
  showFavorite: false,
  spotPage: false,
  externalLinks1: [],
  externalLinks2: [],
  handleFavoriteClick: null,
  pathName: null,
  isMultiPage: false,
};

export default ForecastHeader;
